import { useAbsoluteRoot } from 'helpers/urlRoot';
import React from 'react'
import 'styles/structure/Loader.scss'

export function LoaderEntry() {
    const { urlRoot } = useAbsoluteRoot();
    return (
        <div className={'mirs-overlayEntry'}>
            <div className="center">
                <img
                    src={`${urlRoot}assets/images/pictos/PLoader.gif`}
                    alt="Loading"
                    width={"120px"}
                //style={{ borderRadius: "50%", border: "7px solid black" }}
                />
            </div>
        </div>
    )
}



function Loader() {
    const { urlRoot } = useAbsoluteRoot();
    return (
        <div className="schedule-grid-bgcolor">
            <div className={'mirs-overlay'}>
                <div className="center">
                    <img
                        //src={require("../images/confetti.gif")}

                        src={`${urlRoot}assets/images/pictos/PLoader.gif`}
                        alt="Loading"
                        width={"120px"}
                    //style={{ borderRadius: "50%", border: "7px solid black" }}
                    />
                </div>
            </div>
        </div>
    )
}



export function LoaderPoints({ className = 'mirs-overlay', text = "Loading..." }) {

    return (
        <>
            <div className={className}></div>
            <div className="center">
                <div className="loader">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div className='loader-text'>{text}</div>
            </div>
        </>
    );
}


export default Loader



